import {
  createRef, useRef, useState
} from 'react';
import cn from 'classnames';

export default function DesktopTabButtons({
  activeTab,
  tabLabels,
  tabStyle,
  handleTabClick,
  forceMobile,
}) {
  const [focusedTab, setFocusedTab] = useState(activeTab);
  const btnsRef = useRef(tabLabels.map(() => createRef()));

  // Keyboard interactions should follow this pattern https://www.w3.org/WAI/ARIA/apg/patterns/tabs/#keyboardinteraction
  const handleKeyDown = (e, idx) => {
    const isFirst = idx === 0;
    const isLast = idx === tabLabels.length - 1;

    if (e.code === 'ArrowLeft' && !isFirst) {
      const newIdx = idx - 1;
      const nextBtn = btnsRef.current[newIdx];
      setFocusedTab(tabLabels[newIdx].tabId);
      nextBtn.current.focus();
    }

    if (e.code === 'ArrowRight' && !isLast) {
      const newIdx = idx + 1;
      const nextBtn = btnsRef.current[newIdx];
      setFocusedTab(tabLabels[newIdx].tabId);
      nextBtn.current.focus();
    }
  };

  const handleClick = (e, tabId) => {
    setFocusedTab(tabId);
    handleTabClick(e, tabId);
  };

  return (
    <div
      className={cn(
        'tab-btn-container',
        {
          wrapper: tabStyle !== 'card',
          'tab-btn-container__force-mobile': forceMobile,
        }
      )}
      role="tablist"
    >
      {
        tabLabels.map((label, idx) => (
          <button
            key={label.tabId}
            ref={btnsRef.current[idx]}
            id={`tab-btn-${label.tabId}`}
            className={cn(
              'lds-button-clear-style',
              'tab-btn',
              'focus-3px',
              {
                active: activeTab === label.tabId,
              }
            )}
            onClick={(e) => handleClick(e, label.tabId)}
            role="tab"
            aria-selected={activeTab === label.tabId}
            aria-controls={`tab-panel-${label.tabId}`}
            tabIndex={focusedTab === label.tabId ? 0 : -1}
            onKeyDown={(e) => handleKeyDown(e, idx)}
          >
            {label.label}
          </button>
        ))
      }
    </div>
  );
}
